interface CanvaLogoProps {
    className?: string
    size?: number
}

export function CanvaLogo({ className, size = 20 }: CanvaLogoProps) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm3.192 14.538c-.423.616-1.018.946-1.671.946-1.327 0-2.049-1.263-2.672-2.736l-.478-1.2c-.38-.956-.788-1.438-1.236-1.438-.147 0-.335.1-.508.28l-.423-.538c.624-.692 1.236-1.076 1.73-1.076.96 0 1.57.846 2.188 2.285l.414 1.01c.508 1.236.96 1.87 1.588 1.87.34 0 .625-.18.838-.538l.423.538c-.05.072-.108.16-.193.297z"
                fill="#7D2AE8"
            />
        </svg>
    )
}
